import { Schema } from 'effect';

import { GtmAddPaymentInfoEventSchema } from './add-payment-info';
import { GtmAddShippingInfoEventSchema } from './add-shipping-info';
import { GtmAddToCartEventSchema } from './add-to-cart';
import { GtmCheckoutEventSchema } from './checkout.ts';
import { GtmFormSubmittedEventSchema } from './form-submitted';
import { GtmPageDataEventSchema, GtmPageViewEventSchema } from './page-view';
import { GtmPurchaseEventSchema } from './purchase';
import { GtmRemoveFromCartEventSchema } from './remove-from-cart';
import { GtmSelectItemEventSchema } from './select-item';
import { GtmSelectPromotionEventSchema } from './select-promotion';
import { GtmViewItemEventSchema } from './view-item';

/**
 * Union of all GTM ecommerce events
 *
 * This schema represents all possible GTM dataLayer events in the application.
 * Each event has a distinct 'event' literal type for discrimination.
 */
export const GtmEventSchema = Schema.Union([
  GtmAddToCartEventSchema,
  GtmRemoveFromCartEventSchema,
  GtmCheckoutEventSchema,
  GtmAddPaymentInfoEventSchema,
  GtmAddShippingInfoEventSchema,
  GtmPurchaseEventSchema,
  GtmSelectItemEventSchema,
  GtmSelectPromotionEventSchema,
  GtmViewItemEventSchema,
  GtmFormSubmittedEventSchema,
  GtmPageDataEventSchema,
  GtmPageViewEventSchema,
]).annotate({ identifier: 'GtmEventSchema' });

export type GtmEvent = Schema.Schema.Type<typeof GtmEventSchema>;
